import axios from '@/_legacy/util/axios';
import { authHeader } from '@/_legacy/services/authentication';

function getProducts() {
  return axios.get(
    'v1/plans',
    { headers: authHeader() },
  ).then(({ data }) => data);
}

function getPlan(plan = null, interval = null) {
  return axios.get(
    `v1/plans/${plan}`,
    {
      headers: authHeader(),
      params: {
        interval,
      },
    },
  ).then(({ data }) => data);
}

function getIntent() {
  return axios.get(
    'v1/setup-intents',
    { headers: authHeader() },
  ).then(({ data }) => data);
}

function addCustomerTaxId(vat) {
  return axios.post(
    'v1/vat',
    { vat },
  ).then(({ data }) => data);
}

function removeCustomerTaxId() {
  return axios.delete('v1/vat').then(({ data }) => data);
}

function savePaymentMethod(paymentMethod, company) {
  return axios.post(
    'v2/payment-methods',
    { paymentMethod, company },
  ).then(({ data }) => data);
}

function updatePaymentMethod(billingDetails) {
  return axios.put(
    'v1/payment-methods', { billing_details: billingDetails },
  ).then(({ data }) => data);
}

export default {
  getPlan,
  getProducts,
  getIntent,
  addCustomerTaxId,
  removeCustomerTaxId,
  savePaymentMethod,
  updatePaymentMethod,
};
